import AbstractObject from '../misc/object';
import Line from './line';

export default class Marker extends AbstractObject {

  constructor(options) {
    super(options);

    const halfSize = this.options.size / 2;

    const firstLine = new Line({
      from: {
        x: -halfSize,
        y: 0,
        z: -halfSize
      },
      to: {
        x: halfSize,
        y: 0,
        z: halfSize
      },
      disableDepthTest: true
    });
    this.object.addObject(firstLine);

    const secondLine = new Line({
      from: {
        x: -halfSize,
        y: 0,
        z: halfSize
      },
      to: {
        x: halfSize,
        y: 0,
        z: -halfSize
      },
      disableDepthTest: true
    });
    this.object.addObject(secondLine);
  }

}




// WEBPACK FOOTER //
// ./src/object-view/objects/marker.js